const getters = {
  currentTab: (state) => state.tabs.currentTab,
  info: (state) => state.user.info,
  name: (state) => state.user.name,
  ws: (state) => state.websocket.ws,
  unreadMessageNum: (state) => state.user.unreadMessageNum,
  userInfo: (state) => state.user.contactUserInfo,
  isAdminGroup: (state) => state.user.isAdminGroup,
};

export default getters;
